/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, type ReactNode } from 'react';

interface ShortcutModeContextValue {
  activeShortcutId: string | null;
  setActiveShortcutId: (id: string | null) => void;
  toggleShortcut: (id: string) => void;
}

export const ShortcutModeContext = createContext<ShortcutModeContextValue | null>(null);

export function ShortcutModeProvider({ children }: { children: ReactNode }) {
  const [activeShortcutId, setActiveShortcutId] = useState<string | null>(null);

  const toggleShortcut = (id: string) => {
    setActiveShortcutId((prev) => (prev === id ? null : id));
  };

  return (
    <ShortcutModeContext.Provider value={{ activeShortcutId, setActiveShortcutId, toggleShortcut }}>
      {children}
    </ShortcutModeContext.Provider>
  );
}

export function useShortcutMode() {
  const ctx = useContext(ShortcutModeContext);
  if (!ctx) throw new Error('useShortcutMode must be inside ShortcutModeProvider');
  return ctx;
}
